class ConnectionStatus {
    constructor(serverStatus) {
        this.serverStatus = serverStatus;
    }

    translate(t) {
        return t(`connection-status.${this.serverStatus.toLowerCase().replace(/_/g, '-')}`);
    }

    is(connectionStatus) {
        return connectionStatus === this;
    }
}

export const CONNECTED = new ConnectionStatus('CONNECTED');
export const DISCONNECTED = new ConnectionStatus('DISCONNECTED');
export const CHECKING = new ConnectionStatus('CHECKING');
export const ERROR = new ConnectionStatus('ERROR');

export const getConnectionStatus = (serverStatus) => {
    let result = null;
    switch (serverStatus) {
        case 'CONNECTED':
            result = CONNECTED;
            break;
        case 'DISCONNECTED':
            result = DISCONNECTED;
            break;
        case 'CHECKING':
            result = CHECKING;
            break;
        case 'ERROR':
            result = ERROR;
            break;
        default:
            throw new Error(`Unknown connection status: ${serverStatus}`);
    }
    return result;
};

export const getAllConnectionStatuses = () => [
    CONNECTED,
    DISCONNECTED,
    CHECKING,
    ERROR
];
